<template>
 <label
   class="inline-flex bg-gray-01 rounded-7 py-[6px] px-2"
   :class="{ 'opacity-50': disabled }"
 >
  <slot name="icon"></slot>
  <input
    ref="inputRef"
    type="text"
    v-model="value"
    :readonly="readonly"
    :placeholder="placeholder"
    :class="[
      'w-full focus:outline-none focus:ring-offset-0 focus:ring-0 placeholder:text-gray-04 text-[10px]',
      inputClass,
      { 'bg-gray-200 cursor-not-allowed': disabled }
    ]"
    :style="inputStyle"
    :disabled="disabled"
  />
  <slot name="right"></slot>
 </label>
</template>

<script setup>
import { computed, ref } from 'vue';

const inputRef = ref(null);

const props = defineProps({
 modelValue: {
  type: [String, Number],
  default: ''
 },
 placeholder: {
  type: String,
  default: ''
 },
 readonly: {
  type: Boolean,
  default: false,
 },
 inputClass: {
  type: String,
  default: ''
 },
 inputStyle: {
  type: Object,
  default: () => ({})
 },
 disabled: {
  type: Boolean,
  default: false
 }
})

const emits = defineEmits(['update:model-value'])
const value = computed({
 get() {
  return props.modelValue
 },
 set(val) {
  emits('update:model-value', val)
 },
})

const focus = () => {
  inputRef.value?.focus();
};

defineExpose({ focus });
</script>
